import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var ReturnedToSenderIA = function ReturnedToSenderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9LbFDA",
    defaultMessage: "If you\u2019ve attempted to ship an order, and it\u2019s been returned to you, it could be due to a number of different reasons. Review our <ArticleLinkFormatting>detailed guide</ArticleLinkFormatting> on <BoldFormatting>return to sender</BoldFormatting> issues to find recommended next steps, for both domestic or international shipments.",
    values: {
      ArticleLinkFormatting: ArticleLinkFormatting,
      BoldFormatting: BoldFormatting
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1gsUye",
    defaultMessage: "For more assistance, please contact us. We're always here to help."
  })));
};
var ArticleLinkFormatting = function ArticleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("26594585812891"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};